import "./polyfills";
import * as Pages from "./pages";
import { UserActivity } from "../component";


Object.keys(Pages).forEach((key) => {
	Pages[key]();
});

UserActivity();
